import React, { useState } from 'react';
import { AnalyticsController } from '../../layout/Analytics';
import './Accordion.scss';
import { AccordionRow, AccordionRowInputs } from './AccordionRow';

export interface AccordionInputs {
    title: string;
    items: AccordionRowInputs[];
}

export const Accordion = ({ inputs }: { inputs: AccordionInputs }) => {
    const [items, setItems] = useState(inputs.items);

    function clickHandler() {
        for (const i of items) {
            if (this !== i) i.expanded = false;
        }
        this.expanded = !this.expanded;
        setItems([...items]);
        AnalyticsController.track({
            event: `component click`,
            componentLink: `${inputs.title}: ${this.visibleText}`,
        });
    }

    return (
        <section className="paragraph__accordion kite-container">
            <h2 className="typestack-title-6">{inputs.title}</h2>
            <ul>
                {items.map((item) => (
                    <AccordionRow
                        visibleText={item.visibleText}
                        hiddenText={item.hiddenText}
                        expanded={item.expanded}
                        clickHandler={clickHandler.bind(item)}
                        id={item.id}
                        key={item.id}
                    />
                ))}
            </ul>
        </section>
    );
};
